<template>
  <div>
    <b-sidebar id="sidebar-right-new-entity" v-model="showNewEntityModal" bg-variant="white" right backdrop shadow>
      <NewVaultModalContent v-if="entityType === 'vault'" />
      <NewFolderModalContent v-if="entityType === 'folder'" />
      <NewDocumentModalContent v-if="entityType === 'document'" />
      <NewParticipantModalContent v-if="entityType === 'participant'" />
    </b-sidebar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { VBToggle } from 'bootstrap-vue'
import { BSidebar } from 'bootstrap-vue'
import NewVaultModalContent from './NewVaultModalContent'
import NewFolderModalContent from './NewFolderModalContent'
import NewDocumentModalContent from './NewDocumentModalContent'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSidebar,
    NewVaultModalContent,
    NewFolderModalContent,
    NewDocumentModalContent
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  computed: {
    ...mapState('homeAddNew', ['entityType']),
    showNewEntityModal: {
      get() {
        return this.$store.state.homeAddNew.showNewEntityModal
      },
      set(value) {
        this.$store.dispatch('homeAddNew/onChangeModal', { visible: value })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list-group-item {
  border: none !important;
}
</style>
